<form (submit)="saveAndNext()" [formGroup]="form" (keydown.enter)="saveAndNext()" class="main-form">
  <div class="card mb-4">
    <div class="card-header">
      <fa-icon [icon]="faUsers"></fa-icon> {{ "FLIGHTS.PASSENGERS" | translate }}
    </div>
    <div class="card-body">
      @if (enquiryFlight?.isFerryFlight) {
        <div
          class="alert alert-info text-center mb-0"
          [innerText]="'ENQUIRY_FLIGHT_EDIT.PASSENGERS.IGNORED_FOR_FERRY' | translate"
        ></div>
      }
      @if (enquiry?.type === EnumEnquiryType.cargo) {
        <div
          class="alert alert-info text-center mb-0"
          [innerText]="'ENQUIRY_FLIGHT_EDIT.PASSENGERS.IGNORED_FOR_CARGO' | translate"
        ></div>
      }
      @if (!enquiryFlight?.isFerryFlight && enquiry?.type !== EnumEnquiryType.cargo) {
        <div
          class="row justify-content-center"
          >
          <div class="col-md-6">
            <div class="form-group">
              <label
                for="boardingMinutesBeforeDeparture"
                            [innerText]="
                                'ENQUIRY_FLIGHT_EDIT.PASSENGERS.BOARDING_MINUTES_BEFORE_LABEL'
                                    | translate
                            "
              ></label>
              <div class="input-group">
                <input
                  id="boardingMinutesBeforeDeparture"
                  type="number"
                  min="0"
                  class="form-control"
                  formControlName="boardingMinutesBeforeDeparture"
                                [class.is-invalid]="
                                    (form.touched || boardingMinutesBeforeDeparture.touched) &&
                                    boardingMinutesBeforeDeparture.status == 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  />
                <div class="invalid-tooltip">
                  @if (
                    (form.touched || boardingMinutesBeforeDeparture.touched) &&
                    boardingMinutesBeforeDeparture.errors &&
                    boardingMinutesBeforeDeparture.errors['required']
                    ) {
                    <div
                      [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                    ></div>
                  }
                </div>
                <span
                  class="input-group-text"
                  [innerText]="'GENERAL.MINUTES_SHORT' | translate"
                ></span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label
                for="pax"
                            [innerText]="
                                'FLIGHT_BRIEF.AIRPORT_INFORMATION.NUMBER_OF_PASSENGERS' | translate
                            "
              ></label>
              <input
                type="number"
                class="form-control"
                id="pax"
                formControlName="pax"
                            [class.is-invalid]="
                                (form.touched || pax.touched) && pax.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                />
              <div class="invalid-tooltip">
                @if (
                  (form.touched || pax.touched) &&
                  pax.errors &&
                  pax.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  @if (!enquiryFlight?.isFerryFlight && enquiry?.type !== EnumEnquiryType.cargo) {
    <div
      class="row"
      >
      <div class="col-lg-7">
        <div class="card mb-4">
          <div class="card-header">
            <div class="d-flex align-items-center justify-content-between gap-3">
              <div class="card-title mb-0">
                {{ 'FLIGHTS.PASSENGERS' | translate }} ({{ selectedClientPassengers.length }})
              </div>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="disablePassengerSorting"
                  formControlName="disablePassengerSorting"
                  />
                <label
                  class="form-check-label"
                  for="disablePassengerSorting"
                                [innerText]="
                                    'ENQUIRY_FLIGHT_EDIT.PASSENGERS.MANUAL_PASSENGER_ORDER'
                                        | translate
                                "
                ></label>
              </div>
            </div>
          </div>
          @if (hasAclAccess(EnumAcl.clientPassengersAdd)) {
            <div class="card-body border-bottom">
              <div class="input-group">
                <select class="form-select" [(ngModel)]="selectedPassengerToAddId" [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="null">-- Ajouter un passager --</option>
                  @for (passenger of availableClientPassengersToAdd; track passenger.id) {
                    <option [ngValue]="passenger.id">
                      {{ getFlightBriefPassengerCivilityLabel(passenger.civility, EnumLanguage.fr) }}
                      {{ passenger.lastname }}
                      {{ passenger.firstname }}
                    </option>
                  }
                  <option [ngValue]="createNewPassengerOptionValue">+ Créer un nouveau passager</option>
                </select>
                <button
                  type="button"
                  class="btn btn-primary"
                  [disabled]="!selectedPassengerToAddId"
                  (click)="addPassengerFromDropdown()"
                  >
                  + {{ 'GENERAL.ADD' | translate }}
                </button>
              </div>
            </div>
          }
          @if (!loadingClientPassengers && selectedClientPassengers.length) {
            <ul
              class="list-group list-group-flush"
              >
              @for (passenger of selectedClientPassengers; track passenger.id; let i = $index) {
                <li
                  class="list-group-item"
                  >
                  <div class="d-flex align-items-center justify-content-between">
                    <button
                      type="button"
                      class="btn btn-link p-0 text-start text-decoration-none"
                      (click)="openViewClientPassengerModal(passenger)"
                      >
                      {{ getFlightBriefPassengerCivilityLabel(passenger.civility, EnumLanguage.fr) }}
                      {{ passenger.lastname }}
                      {{ passenger.firstname }}
                    </button>
                    <div class="btn-group">
                      @if (isManualPassengerSortingEnabled) {
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm"
                          (click)="moveSelectedPassenger(passenger.id, 'up')"
                          [disabled]="i === 0"
                          >
                          <fa-icon [icon]="faArrowUp"></fa-icon>
                        </button>
                      }
                      @if (isManualPassengerSortingEnabled) {
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm"
                          (click)="moveSelectedPassenger(passenger.id, 'down')"
                          [disabled]="i === selectedClientPassengers.length - 1"
                          >
                          <fa-icon [icon]="faArrowDown"></fa-icon>
                        </button>
                      }
                      @if (hasAclAccess(EnumAcl.clientPassengersEdit)) {
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          (click)="openEditClientPassengerModal(passenger)"
                          >
                          <fa-icon [icon]="faEdit"></fa-icon>
                        </button>
                      }
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        (click)="removeSelectedPassenger(passenger.id)"
                        >
                        <fa-icon [icon]="faMinus"></fa-icon>
                      </button>
                    </div>
                  </div>
                </li>
              }
            </ul>
          }
          @if (loadingClientPassengers) {
            <div class="card-body">
              <div class="placeholder-glow">
                @for (number of [].constructor(4); track $index) {
                  <div class="placeholder w-100"></div>
                }
              </div>
            </div>
          }
        </div>
        <div class="card mb-4">
          <div class="card-header">
            <div
              class="card-title mb-0 text-center"
                        [innerText]="
                            pets.length > 1
                                ? ('ENQUIRY_FLIGHT_EDIT.PASSENGERS.PETS_PLURAL' | translate)
                                : ('ENQUIRY_FLIGHT_EDIT.PASSENGERS.PETS_SINGULAR' | translate)
                        "
            ></div>
          </div>
          <ul class="list-group list-group-flush" formArrayName="pets">
            @for (pet of pets.controls; track pet; let i = $index) {
              <li
                class="list-group-item"
                [formGroupName]="i"
                >
                <div class="row justify-content-center">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label
                        [attr.for]="'pet-' + i + '-petType'"
                                        [innerText]="
                                            'ENQUIRY_FLIGHT_EDIT.PASSENGERS.PET_PRESET_LABEL'
                                                | translate
                                        "
                      ></label>
                      <select
                        class="form-select"
                        [id]="'pet-' + i + '-petType'"
                        formControlName="petType"
                                        [class.is-invalid]="
                                            (form.touched || getPetField(i, 'petType').touched) &&
                                            getPetField(i, 'petType').status === 'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                        >
                        @for (option of petTypeOptions; track option) {
                          <option
                            [ngValue]="option.value"
                            >
                            {{ option.labelKey | translate }}
                          </option>
                        }
                      </select>
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched ||
                          getPetField(i, 'petType').touched) &&
                          getPetField(i, 'petType').errors &&
                          getPetField(i, 'petType').errors['required']
                          ) {
                          <div
                            [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                          ></div>
                        }
                      </div>
                    </div>
                    @if (
                      getPetField(i, 'petType').value ===
                      EnumFlightBriefPetType.other
                      ) {
                      <div
                        class="form-group mt-3"
                        >
                        <label
                          [attr.for]="'pet-' + i + '-type'"
                                        [innerText]="
                                            'ENQUIRY_FLIGHT_EDIT.PASSENGERS.PET_TYPE_CUSTOM_LABEL'
                                                | translate
                                        "
                        ></label>
                        <input
                          [id]="'pet-' + i + '-type'"
                          type="text"
                          class="form-control"
                          formControlName="type"
                                        [class.is-invalid]="
                                            (form.touched || getPetField(i, 'type').touched) &&
                                            getPetField(i, 'type').status == 'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                                        [attr.placeholder]="
                                            'ENQUIRY_FLIGHT_EDIT.PASSENGERS.PET_TYPE_PLACEHOLDER'
                                                | translate
                                        "
                          />
                        <div class="invalid-tooltip">
                          @if (
                            (form.touched || getPetField(i, 'type').touched) &&
                            getPetField(i, 'type').errors &&
                            getPetField(i, 'type').errors['required']
                            ) {
                            <div
                              [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                            ></div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label
                        [attr.for]="'pet-' + i + '-name'"
                        [innerText]="'GENERAL.NAME' | translate"
                      ></label>
                      <input
                        [id]="'pet-' + i + '-name'"
                        type="text"
                        class="form-control"
                        formControlName="name"
                                        [class.is-invalid]="
                                            (form.touched || getPetField(i, 'name').touched) &&
                                            getPetField(i, 'name').status == 'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                        />
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched || getPetField(i, 'name').touched) &&
                          getPetField(i, 'name').errors &&
                          getPetField(i, 'name').errors['required']
                          ) {
                          <div
                            [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                          ></div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 d-flex align-self-center justify-content-end">
                    <button type="button" (click)="removePet(i)" class="btn btn-danger">
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  </div>
                </div>
              </li>
            }
          </ul>
          <div class="card-footer text-center">
            <button type="button" class="btn btn-primary" (click)="addPet()">
              + {{ "GENERAL.ADD" | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="card mb-4">
          <div class="card-body">
            <div class="form-group placeholder-glow">
              @if (loadingFlightBriefCaterings) {
                <div class="placeholder w-100"></div>
              }
              <label for="flightBriefCateringId">
                <span [innerText]="'FLIGHT_BRIEF.CATERING' | translate"></span>
                @if (hasAclAccess(EnumAcl.flightBriefCateringsAdd)) {
                  <button
                    type="button"
                    (click)="addFlightBriefCatering()"
                    class="btn btn-icon ms-2"
                    [disabled]="loadingFlightBriefCaterings"
                    >
                    <fa-icon [icon]="faCirclePlus"></fa-icon>
                  </button>
                }
              </label>
              @if (!loadingFlightBriefCaterings) {
                <div
                  [class.input-group]="flightBriefCateringId.value"
                  >
                  <select
                    class="form-select"
                    id="flightBriefCateringId"
                    formControlName="flightBriefCateringId"
                                [class.is-invalid]="
                                    (form.touched || flightBriefCateringId.touched) &&
                                    flightBriefCateringId.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                    (change)="updatedFlightBriefCateringId()"
                    >
                    <option
                      [ngValue]="null"
                      [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                    ></option>
                    @for (
                      flightBriefCatering of displayedFlightBriefCaterings
                      ; track
                      flightBriefCatering.id) {
                      <option
                        [value]="flightBriefCatering.id"
                                    [innerHtml]="
                                        flightBriefCatering.textByLanguage
                                            ? flightBriefCatering.textByLanguage[EnumLanguage.fr]
                                            : ''
                                    "
                      ></option>
                    }
                    <option
                      value="custom"
                      [innerText]="'FLIGHT_BRIEF.CATERING_CUSTOM' | translate"
                    ></option>
                  </select>
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched || flightBriefCateringId.touched) &&
                      flightBriefCateringId.errors &&
                      flightBriefCateringId.errors['required']
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                  @if (
                    hasAclAccess(EnumAcl.flightBriefCateringsEdit) &&
                    flightBriefCateringId.value
                    ) {
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="editFlightBriefCatering()"
                                [appTooltip]="
                                    ('GENERAL.EDIT' | translate) +
                                    ' ' +
                                    ('FLIGHT_BRIEF.CATERING' | translate)
                                "
                      >
                      <fa-icon [icon]="faEdit"></fa-icon>
                    </button>
                  }
                </div>
              }
              @if (flightBriefCateringId.value === 'custom') {
                <textarea
                  class="form-control"
                  rows="2"
                  id="catering"
                  formControlName="catering"
                            [class.is-invalid]="
                                (form.touched || catering.touched) && catering.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                  placeholder="Saisissez le catering"
                ></textarea>
              }
              <div class="invalid-tooltip">
                @if (
                  (form.touched || catering.touched) &&
                  catering.errors &&
                  catering.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
            <div class="form-group">
              <label
                for="beverages"
                            [innerText]="
                                'FLIGHT_BRIEF.ONBOARD_INFORMATION.BEVERAGES_ON_BOARD' | translate
                            "
              ></label>
              <input
                type="text"
                class="form-control"
                id="beverages"
                formControlName="beverages"
                            [class.is-invalid]="
                                (form.touched || beverages.touched) &&
                                beverages.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                />
              <div class="invalid-tooltip">
                @if (
                  (form.touched || beverages.touched) &&
                  beverages.errors &&
                  beverages.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
            <div class="form-group mb-0">
              <label for="luggages" class="d-block mb-1"
                >Bagages par passager
                <div class="form-check form-switch float-end">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    formControlName="luggageIsCustom"
                    (change)="updateLuggageIsCustom()"
                    id="luggageIsCustom"
                    />
                  <label class="form-check-label" for="luggageIsCustom"
                    >Personnalisé</label
                    >
                  </div>
                </label>
                <div class="clearfix"></div>
                @if (!luggageIsCustom.value) {
                  <ul class="list-group">
                    @if (
                      ![EnumEnquiryType.commercial, EnumEnquiryType.sport].includes(
                      $safeNavigationMigration(enquiryFlight?.enquiryType)
                      )
                      ) {
                      <li
                        class="list-group-item"
                        >
                        <label
                                    [innerText]="
                                        'ENQUIRY_FLIGHT_EDIT.PASSENGERS.LUGGAGE_QTY' | translate
                                    "
                        ></label>
                        <div class="selectors-increment-number">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            [disabled]="luggageQty.value <= 0"
                            (click)="updateLuggageQty(-1)"
                            >
                            -
                          </button>
                          <div
                            class="selector-number-value"
                            [innerText]="luggageQty.value"
                          ></div>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="updateLuggageQty(1)"
                            >
                            +
                          </button>
                        </div>
                      </li>
                    }
                    @if (
                      ![EnumEnquiryType.commercial, EnumEnquiryType.sport].includes(
                      $safeNavigationMigration(enquiryFlight?.enquiryType)
                      )
                      ) {
                      <li
                        class="list-group-item"
                        >
                        <label
                                    [innerText]="
                                        'ENQUIRY_FLIGHT_EDIT.PASSENGERS.LUGGAGE_WEIGHT_PER_BAG'
                                            | translate
                                    "
                        ></label>
                        <div class="selectors-increment-number">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            [disabled]="luggagesWeight.value <= 0"
                            (click)="updateLuggageWeight(-1)"
                            >
                            -
                          </button>
                          <div
                            class="selector-number-value"
                                        [innerText]="
                                            luggagesWeight.value > 1
                                                ? luggagesWeight.value + ' kgs'
                                                : luggagesWeight.value + ' kg'
                                        "
                          ></div>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="updateLuggageWeight(1)"
                            >
                            +
                          </button>
                        </div>
                      </li>
                    }
                    @if (
                      [EnumEnquiryType.commercial, EnumEnquiryType.sport].includes(
                      $safeNavigationMigration(enquiryFlight?.enquiryType)
                      )
                      ) {
                      <li
                        class="list-group-item"
                        >
                        <label
                                    [innerText]="
                                        'FLIGHT_BRIEF.AIRPORT_INFORMATION.LUGGAGES_LIMIT_IN_HOLD_IN_KG'
                                            | translate
                                    "
                        ></label>
                        <div class="selectors-increment-number">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            [disabled]="luggagesLimitInHoldInKg.value <= 0"
                            (click)="updateLuggagesLimitInHoldInKg(-1)"
                            >
                            -
                          </button>
                          <div
                            class="selector-number-value"
                                        [innerText]="
                                            luggagesLimitInHoldInKg.value > 1
                                                ? luggagesLimitInHoldInKg.value + ' kgs'
                                                : luggagesLimitInHoldInKg.value + ' kg'
                                        "
                          ></div>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="updateLuggagesLimitInHoldInKg(1)"
                            >
                            +
                          </button>
                        </div>
                      </li>
                    }
                    @if (
                      [EnumEnquiryType.commercial, EnumEnquiryType.sport].includes(
                      $safeNavigationMigration(enquiryFlight?.enquiryType)
                      )
                      ) {
                      <li
                        class="list-group-item"
                        >
                        <label
                                    [innerText]="
                                        'FLIGHT_BRIEF.AIRPORT_INFORMATION.LUGGAGES_LIMIT_IN_CABIN_IN_KG'
                                            | translate
                                    "
                        ></label>
                        <div class="selectors-increment-number">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            [disabled]="luggagesLimitInCabinInKg.value <= 0"
                            (click)="updateLuggagesLimitInCabinInKg(-1)"
                            >
                            -
                          </button>
                          <div
                            class="selector-number-value"
                                        [innerText]="
                                            luggagesLimitInCabinInKg.value > 1
                                                ? luggagesLimitInCabinInKg.value + ' kgs'
                                                : luggagesLimitInCabinInKg.value + ' kg'
                                        "
                          ></div>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="updateLuggagesLimitInCabinInKg(1)"
                            >
                            +
                          </button>
                        </div>
                      </li>
                    }
                  </ul>
                }
                @if (luggageIsCustom.value) {
                  <textarea
                    class="form-control"
                    rows="1"
                    id="luggages"
                    formControlName="luggages"
                                [class.is-invalid]="
                                    (form.touched || luggages.touched) &&
                                    luggages.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  ></textarea>
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched || luggages.touched) &&
                      luggages.errors &&
                      luggages.errors['required']
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="row mb-4">
      <div class="col">
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="form.disabled"
          (click)="prev()"
          >
          <fa-icon [icon]="faArrowLeft"></fa-icon>
          {{ "GENERAL.PREVIOUS" | translate }}
        </button>
      </div>
      <div class="col text-end">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="form.disabled || !form.valid"
          (click)="saveAndNext()"
          >
          {{ "GENERAL.NEXT" | translate }}
          <fa-icon [icon]="faArrowRight"></fa-icon>
        </button>
      </div>
    </div>
  </form>

  <div class="modal" tabindex="-1" role="dialog" #modalFlightBriefCatering>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
                    [innerText]="
                        editingFlightBriefCatering
                            ? ('FLIGHT_BRIEF.EDIT_CATERING' | translate)
                            : ('FLIGHT_BRIEF.ADD_CATERING' | translate)
                    "
          ></h5>
          <button
            type="button"
            class="btn-close"
            [attr.aria-label]="'GENERAL.CLOSE' | translate"
            (click)="dismissFlightBriefCateringModal()"
          ></button>
        </div>
        <app-flight-brief-catering-edit
          [inModal]="true"
          [flightBriefCateringId]="editingFlightBriefCatering?.id || null"
          (dismissModal)="dismissFlightBriefCateringModal($event)"
        ></app-flight-brief-catering-edit>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" role="dialog" #modalClientPassengerView>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      @if (viewingClientPassenger) {
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ getFlightBriefPassengerCivilityLabel(viewingClientPassenger.civility, EnumLanguage.fr) }}
              {{ viewingClientPassenger.lastname }}
              {{ viewingClientPassenger.firstname }}
            </h5>
            <button
              type="button"
              class="btn-close"
              [attr.aria-label]="'GENERAL.CLOSE' | translate"
              (click)="dismissClientPassengerViewModal()"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-lg-6">
                <div class="card h-100">
                  <div class="card-header">
                    {{ 'CLIENT_PASSENGERS.PASSPORT' | translate }}
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>{{ 'CLIENT_PASSENGERS.PASSPORT_NUMBER' | translate }}</strong>
                      <span>{{ viewingClientPassenger.passport?.number || '-' }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>{{ 'CLIENT_PASSENGERS.EXPIRATION_DATE' | translate }}</strong>
                      <span>{{ viewingClientPassenger.passport?.expirationDate || '-' }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>{{ 'GENERAL.DOCUMENT' | translate }}</strong>
                      @if (viewingClientPassenger.passport?.document?.url) {
                        <a
                          [href]="viewingClientPassenger.passport.document.url"
                          target="_blank"
                          >
                          {{ viewingClientPassenger.passport.document.name || ('GENERAL.OPEN' | translate) }}
                        </a>
                      }
                      @if (!viewingClientPassenger.passport?.document?.url) {
                        <span>-</span>
                      }
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="card h-100">
                  <div class="card-header">
                    {{ 'CLIENT_PASSENGERS.IDENTITY_CARD' | translate }}
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>{{ 'CLIENT_PASSENGERS.EXPIRATION_DATE' | translate }}</strong>
                      <span>{{ viewingClientPassenger.identityCard?.expirationDate || '-' }}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>{{ 'GENERAL.DOCUMENT' | translate }}</strong>
                      @if (viewingClientPassenger.identityCard?.document?.url) {
                        <a
                          [href]="viewingClientPassenger.identityCard.document.url"
                          target="_blank"
                          >
                          {{ viewingClientPassenger.identityCard.document.name || ('GENERAL.OPEN' | translate) }}
                        </a>
                      }
                      @if (!viewingClientPassenger.identityCard?.document?.url) {
                        <span>-</span>
                      }
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-12">
                <div class="card">
                  <div class="card-header">
                    {{ 'CLIENT_PASSENGERS.OTHER_DOCUMENTS' | translate }}
                  </div>
                  @if (viewingClientPassenger.otherDocuments?.length) {
                    <ul
                      class="list-group list-group-flush"
                      >
                      @for (doc of viewingClientPassenger.otherDocuments; track doc) {
                        <li class="list-group-item">
                          <div class="fw-bold mb-1">{{ doc.name }}</div>
                          <div class="d-flex justify-content-between">
                            <strong>{{ 'CLIENT_PASSENGERS.EXPIRATION_DATE' | translate }}</strong>
                            <span>{{ doc.expirationDate || '-' }}</span>
                          </div>
                          <div class="d-flex justify-content-between mt-1">
                            <strong>{{ 'GENERAL.DOCUMENT' | translate }}</strong>
                            @if (doc.document?.url) {
                              <a [href]="doc.document.url" target="_blank">
                                {{ doc.document.name || ('GENERAL.OPEN' | translate) }}
                              </a>
                            }
                            @if (!doc.document?.url) {
                              <span>-</span>
                            }
                          </div>
                        </li>
                      }
                    </ul>
                  } @else {
                    <div class="card-body text-muted">-</div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="modal" tabindex="-1" role="dialog" #modalClientPassengerEdit>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            [innerText]="editingClientPassenger ? ('GENERAL.EDIT' | translate) : ('GENERAL.ADD' | translate)"
          ></h5>
          <button
            type="button"
            class="btn-close"
            [attr.aria-label]="'GENERAL.CLOSE' | translate"
            (click)="dismissClientPassengerEditModal()"
          ></button>
        </div>
        <div class="modal-body" [formGroup]="editClientPassengerForm">
          <div class="form-group mb-3">
            <label for="editPassengerCivility" [innerText]="'GENERAL.CIVILITY' | translate"></label>
            <select id="editPassengerCivility" class="form-select" formControlName="civility">
              @for (civility of getCivilities(); track civility) {
                <option [value]="civility">
                  {{ getFlightBriefPassengerCivilityLabel(civility, EnumLanguage.fr) }}
                </option>
              }
            </select>
          </div>
          <div class="form-group mb-3">
            <label for="editPassengerLastname" [innerText]="'GENERAL.LASTNAME' | translate"></label>
            <input id="editPassengerLastname" type="text" class="form-control" formControlName="lastname" />
          </div>
          <div class="form-group mb-0">
            <label for="editPassengerFirstname" [innerText]="'GENERAL.FIRSTNAME' | translate"></label>
            <input id="editPassengerFirstname" type="text" class="form-control" formControlName="firstname" />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="dismissClientPassengerEditModal()"
            [disabled]="savingEditedClientPassenger"
            [innerText]="'GENERAL.CANCEL' | translate"
          ></button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="saveEditedClientPassenger()"
            [disabled]="savingEditedClientPassenger || !editClientPassengerForm.valid"
            [innerText]="(savingEditedClientPassenger ? 'GENERAL.SAVING' : 'GENERAL.SAVE') | translate"
          ></button>
        </div>
      </div>
    </div>
  </div>
